module.exports = __webpack_public_path__ + "img/14.0aeef9b5.jpg";